/* Gli ultimi prodotti guardati.
 *
 * Servono a una cosa sola: quando il carrello e' vuoto, dare un punto da cui
 * riprendere invece di un vicolo cieco.
 *
 * Sta tutto nel browser di chi naviga (`localStorage`), non sul server: sono
 * abitudini di navigazione, non ci interessa raccoglierle e non devono uscire
 * dal suo telefono. Ne consegue che l'elenco non esiste alla prima visita, e
 * che sparisce se qualcuno pulisce i dati del sito. E' il comportamento
 * giusto, non un limite: il blocco resta nascosto e il carrello vuoto dice
 * semplicemente com'e' andata.
 *
 * Ogni accesso e' protetto: in navigazione privata, con i dati del sito
 * bloccati o con la memoria piena, `localStorage` non solo torna vuoto ma
 * *solleva un errore*. Senza try/catch il carrello vuoto resterebbe bianco.
 */
(function () {
  'use strict';

  if (window.vdmVistiPronti) return;
  window.vdmVistiPronti = true;

  var CHIAVE = 'vdm-visti';
  var QUANTI = 4;

  function leggi() {
    try {
      var grezzo = window.localStorage.getItem(CHIAVE);
      var elenco = grezzo ? JSON.parse(grezzo) : [];
      return Array.isArray(elenco) ? elenco : [];
    } catch (e) {
      return [];
    }
  }

  function scrivi(elenco) {
    try {
      window.localStorage.setItem(CHIAVE, JSON.stringify(elenco));
    } catch (e) {
      /* memoria piena o scrittura vietata: si prosegue senza ricordare */
    }
  }

  /* --- registrazione: la fa la scheda prodotto ----------------------------- */

  function segna() {
    var dati = document.querySelector('[data-vdm-visto]');
    if (!dati) return;

    var voce = {
      handle: dati.dataset.vdmVisto,
      titolo: dati.dataset.vdmTitolo || '',
      prezzo: dati.dataset.vdmPrezzo || '',
      url: dati.dataset.vdmUrl || '',
      img: dati.dataset.vdmImg || '',
      alt: dati.dataset.vdmAlt || ''
    };
    if (!voce.handle || !voce.url) return;

    var elenco = leggi().filter(function (v) {
      return v && v.handle !== voce.handle;
    });
    elenco.unshift(voce);
    scrivi(elenco.slice(0, QUANTI));
  }

  /* --- resa: la fa il carrello vuoto --------------------------------------- */

  function testo(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function mostra() {
    var blocco = document.querySelector('[data-visti]');
    var lista = document.querySelector('[data-visti-lista]');
    if (!blocco || !lista) return;

    var elenco = leggi();
    if (!elenco.length) {
      blocco.hidden = true;
      return;
    }

    lista.innerHTML = elenco
      .map(function (v) {
        // I valori arrivano da localStorage, quindi da una fonte che si puo'
        // manomettere: passano tutti da textContent, mai da innerHTML diretto.
        var figura = v.img
          ? '<img class="vdm-visti__img" src="' + testo(v.img) + '" alt="" width="120" height="150" loading="lazy">'
          : '';
        return (
          '<li class="vdm-visti__voce">' +
          '<a class="vdm-visti__link" href="' + testo(v.url) + '">' +
          '<span class="vdm-visti__scena">' + figura + '</span>' +
          '<span class="vdm-visti__nome">' + testo(v.titolo) + '</span>' +
          '<span class="vdm-visti__prezzo">' + testo(v.prezzo) + '</span>' +
          '</a></li>'
        );
      })
      .join('');
    blocco.hidden = false;
  }

  function avvia() {
    segna();
    mostra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  // Il cassetto viene ri-renderizzato quando il carrello cambia: se si svuota
  // togliendo l'ultimo prodotto, il blocco va ridisegnato o resterebbe vuoto
  // proprio nel momento in cui serve.
  //
  // `subscribe` e `PUB_SUB_EVENTS` sono const globali di pubsub.js e
  // constants.js, non proprieta' di window: vanno cercate per nome con typeof,
  // non come window.subscribe — che e' sempre undefined.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, mostra);
  }
})();
